import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { SiTicktick } from "react-icons/si";
import { FaUser, FaLock, FaCalendarAlt } from "react-icons/fa";
import './PrivacyAndConsent.scss';
import { useNavigate } from 'react-router-dom';

export default function PrivacyAndConsentComponent({ isMobile, mainProps, showSidebar }) {
    const navigate = useNavigate();
    const { main, mainLoading, mainError } = mainProps;
    const [selected, setSelected] = useState('communications')

    const handleClick = (section) => {
        toast.success(`Modification request for ${section} was sent to the bank representavies, you will get a call for update soon.`);
    }

    return (
        <div
            className="container-fluid bg-col transition-width"
            style={!isMobile ? {
                width: showSidebar ? 'calc(100% - 332px)' : '100%',
                marginLeft: 0,
                marginRight: 'auto',
                transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
            } : {}}
        >
            <div className="row p-3 privacy-consent-panel mb-5">
                <h5 className="mb-5 mt-2">PRIVACY AND CONSENTS</h5>
                <p className="text-muted" >
                    In this section, you can manage your preferences regarding <strong>consent for the processing of personal data</strong> and choose how you wish to receive <strong>communications related to account management and invoice delivery</strong>.
                </p>
                <p className="text-muted" >
                    You can find useful information on the protecion of Personal Data in the <a href='https://artesiab.com/payment-processing-services-agreement/' target='_blank'>Privacy section of the institutional website</a>.
                </p>

                <div className="bg-secondary-privacy-consent-panel position-relative">
                    <div className="tab-container d-flex mt-3">
                        <div
                            className={`tab-item ${selected === 'communications' ? 'active' : ''}`}
                            onClick={() => setSelected('communications')}
                            style={isMobile ? { marginLeft: "15px" } : {}}
                        >
                            <p className={`${selected === 'communications' ? 'p-privacy-consents' : 'text-muted'}`}>
                                <strong>DAILY COMMUNICATIONS</strong>
                            </p>
                        </div>
                        <div
                            className={`tab-item ${selected === 'consents' ? 'active' : ''}`}
                            onClick={() => setSelected('consents')}
                            style={isMobile ? { marginLeft: "15px" } : {}}
                        >
                            <p className={`${selected === 'consents' ? 'p-privacy-consents' : 'text-muted'}`}>
                                <strong>CONSENTS</strong>
                            </p>
                        </div>
                    </div>
                </div>

                {selected === 'communications' ? (
                    <>
                        <div className='mt-4'>
                            <h5 className="mb-4 mt-2">Where you receive daily communication?</h5>
                            <p className="text-muted mb-0">Below you can check where to <strong>receive daily communication</strong> in line with the <a href='https://artesiab.com/payment-processing-services-agreement/' target='_blank'>privacy consent</a>.</p>
                            <p className="text-muted">These settings show all the <strong>operational communication</strong> that you receive as usual.</p>

                            <div className='d-flex flex-column gap-2 mb-4' style={{ marginLeft: "40px" }}>
                                <div className="d-flex align-items-center gap-2 my-2">
                                    <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    <span>SMS</span>
                                </div>
                                <div className="d-flex align-items-center gap-2 my-2">
                                    <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    <span>EMAIL</span>
                                </div>
                                <div className="d-flex align-items-center gap-2 my-2">
                                    <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    <span>Telephone (Contact Center)</span>
                                </div>
                                <div className="d-flex align-items-center gap-2 my-2">
                                    <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    <span>Virtual Assistant</span>
                                </div>
                                <div className="d-flex align-items-center gap-2 my-2">
                                    <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    <span>App Notifications</span>
                                </div>
                            </div>

                            <p className="text-muted">Please note that once a change is requested, it may take up to 24 hour for it to take effect.</p>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="mt-4">
                            <h5 className="mb-4 mt-2">Your Consent Preferences</h5>
                            <p className="text-muted mb-0">
                                Below you can find a summary of the <strong>consents</strong> you have provided in accordance with our <a href="https://artesiab.com/payment-processing-services-agreement/" target="_blank" rel="noopener noreferrer">privacy consent</a>.
                            </p>
                            <p className="text-muted">
                                These settings help us ensure secure, compliant, and personalized banking services.
                            </p>

                            <div className="d-flex flex-column gap-2 mb-4" style={isMobile ? { marginLeft: "10px" } : { marginLeft: "40px" }}>
                                <div className="d-flex align-items-start gap-2 my-2">
                                    <span style={{ flexShrink: 0 }}>
                                        <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    </span>
                                    <p className="text-muted mb-0">
                                        <strong>Personal Data Processing</strong> – Consent to the collection and secure handling of your personal and financial information for account services.
                                    </p>
                                </div>

                                <div className="d-flex align-items-start gap-2 my-2">
                                    <span style={{ flexShrink: 0 }}>
                                        <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    </span>
                                    <p className="text-muted mb-0" >
                                        <strong>Electronic Communication Delivery</strong> – Receive legally required documents such as statements and invoices in digital format.
                                    </p>
                                </div>

                                <div className="d-flex align-items-start gap-2 my-2">
                                    <span style={{ flexShrink: 0 }}>
                                        <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    </span>
                                    <p className="text-muted mb-0" >
                                        <strong>Contact Preferences</strong> – Contact regarding account activity, such as via SMS, email, phone, or app notifications.
                                    </p>
                                </div>

                                <div className="d-flex align-items-start gap-2 my-2">
                                    <span style={{ flexShrink: 0 }}>
                                        <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    </span>
                                    <p className="text-muted mb-0" >
                                        <strong>Authentication Methods</strong> – Use multi-factor authentication methods (e.g. OTP, biometrics) for secure login and transaction approval.
                                    </p>
                                </div>

                                <div className="d-flex align-items-start gap-2 my-2">
                                    <span style={{ flexShrink: 0 }}>
                                        <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    </span>
                                    <p className="text-muted mb-0" >
                                        <strong>Transaction Monitoring</strong> – Acknowledge that your account activity may be monitored to detect and prevent fraud or suspicious behavior.
                                    </p>
                                </div>

                                <div className="d-flex align-items-start gap-2 my-2">
                                    <span style={{ flexShrink: 0 }}>
                                        <SiTicktick size={30} style={{ color: "#6A343A" }} />
                                    </span>
                                    <p className="text-muted mb-0" >
                                        <strong>Data Retention</strong> – Secure storage of your personal and financial data for a legally mandated retention period.
                                    </p>
                                </div>
                            </div>

                            <p className="text-muted">
                                Please note that changes to your consent preferences may take up to 24 hours to be reflected across all our systems.
                            </p>
                        </div>
                    </>
                )}

                <div className={`my-5 ${isMobile ? "text-center" : "text-end"}`}>
                    <button className='btn rounded-pill balaneCustom-bg-secondary' onClick={() => handleClick(selected.toUpperCase())}>MODIFICATION REQUEST</button>
                </div>


                {isMobile && (
                    <section className="d-block d-md-none mt-4 px-3 pb-5">
                        <h5 className="text-muted fw-semibold mb-4">You may also need to manage:</h5>
                        <div className="d-grid gap-3">
                            <div
                                onClick={() => navigate("/personal-data")}
                                className="d-flex align-items-center gap-3 p-3 bg-light border rounded-4 shadow-sm cursor-pointer hover-bg"
                            >
                                <FaUser size={25} style={{ color: "#1E266D" }} />
                                <span className="fw-medium text-dark">Personal Data</span>
                            </div>

                            <div
                                onClick={() => navigate("/passwords")}
                                className="d-flex align-items-center gap-3 p-3 bg-light border rounded-4 shadow-sm cursor-pointer hover-bg"
                            >
                                <FaLock size={25} style={{ color: "#1E266D" }} />
                                <span className="fw-medium text-dark">Passwords</span>
                            </div>

                            <div
                                onClick={() => navigate("/calendar-appointments")}
                                className="d-flex align-items-center gap-3 p-3 bg-light border rounded-4 shadow-sm cursor-pointer hover-bg"
                            >
                                <FaCalendarAlt size={25} style={{ color: "#1E266D" }} />
                                <span className="fw-medium text-dark">My Calendar</span>
                            </div>

                        </div>
                    </section>
                )}
            </div>
        </div >
    );
}